<template>
  <div>
    <div class="demoboxAdd">
      <el-upload
        action="/service-center/upload/file/single"
        :on-success="handleSuccess"
        class="hiddenInput"
        :headers="headers"
        :before-upload="beforeAvatarUpload"
        accept=".jpg,.jpeg,.png"
        :show-file-list="false"
      >
        <img height="215" width="320" :src="worksImgs? worksImgs : workImg" alt="" />
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "uploadDesignerImg",
  data() {
    return {
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      worksImgs: '',
      workImg: require("../../assets/images/work.png"),
    };
  },
//   computed:{
//     workImg(){
//         // 如果是模型require("../../assets/images/model.png")
//         // 如果是平面require("../../assets/images/work.png")
//     }
//   },
  methods: {
    handleSuccess(obj) {
      this.worksImgs = obj.url;
      this.$emit('worksImgs',obj)
    },
    beforeAvatarUpload(file) {
      let fileTypes = [
        ".jpg",
        ".png",
        ".jpeg",
        ".bmp",
        ".JPG",
        ".PNG",
        ".JPEG",
        ".BMP",
      ];
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      let fileIndex = fileTypes.indexOf(fileTypeName);
      if (fileIndex === -1) {
        this.$alert("只能上传图片格式", "提示", {
          confirmButtonText: "确定",
        });
      }
      return fileIndex !== -1;
    },
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/uploadDesignerImg/uploadDesignerImg.vue